module.exports = __webpack_public_path__ + "621ab95acac993fdc788ec1e9560bf62.png";